import { isApplicationNotSourcedByAiRecruiter } from '@/core/conversations/application-score/application-score.util';
import { getIntegrationDisplayName } from '@/core/conversations/conversation-index/ats-source.util';
import { CandidateOrigin } from '@/core/conversations/conversation-index/candidate-origin.enum';
import type { ApplicationIndex } from '@/core/conversations/conversation-index/conversation-index.type';

export type CandidateOriginFields = Partial<
  Pick<ApplicationIndex, 'integrationId' | 'initiatedByCopilot' | 'initiatedByOutreach'>
>;

/**
 * Resolves the bucket a candidate row belongs to. The ladder — and its order — is the one
 * `ApplicantOriginChip.vue` renders, so a row's chip always agrees with the bucket it was
 * filtered into. `initiatedByCopilot` without `initiatedByOutreach` deliberately reads as
 * APPLICANT: the chip has no branch for it (ONE-7281).
 */
export function getCandidateOrigin(application?: CandidateOriginFields | null): CandidateOrigin {
  if (getIntegrationDisplayName(application?.integrationId)) {
    return CandidateOrigin.ATS;
  }

  if (application?.initiatedByCopilot && application?.initiatedByOutreach) {
    return CandidateOrigin.AI_SOURCED;
  }

  if (
    isApplicationNotSourcedByAiRecruiter(
      application?.initiatedByOutreach,
      application?.initiatedByCopilot,
    )
  ) {
    return CandidateOrigin.SOURCED;
  }

  return CandidateOrigin.APPLICANT;
}
